import React from 'react';
import {Component} from 'react';
import {connect} from 'react-redux';

import _ from "lodash";
import ReactTable from 'react-table';
import "react-table/react-table.css";

import DrilldownModal from '../Generic/DrilldownModal';
import FilingReportTypeSelector from '../Generic/ReportTypeSelector';
import {LocalListingFlowEnum, VATNumberChecksEnum} from '../../../utils/enums';
import Pagination from '../../page/Pagination';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ReactComponentHelper from '../../helper/ReactComponentHelper';
import NoData from '../../page/NoData';
import ExportAll from '../../common/ExportAll';

import FILING_CONTROLLER from '../../../controllers/filing';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
const log = new Logger('LOCAL_LISTING_FILING_VALUES', LOG_LEVELS.DEBUG);

const LISTING_TYPE_SALES = 0;
const modalStyle = { modal: 'modal-full-width modal-max-width-75' };

const CSV_HEADERS = [
    'VAT Number', 'Total Amount', 'Total Amount Excl VAT', 'Total Amount VAT',
    'In/Out', 'VIES Check', 'Name', 'Company Name Check', 'Extra Info',
    'Invoice Number', 'Supplier Invoice Number'
];

function escapeCSVField(field) {
    const str = String(field);
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
}

function buildCheckedVATIndex(checkedVATNumbers) {
    const index = {};
    if (!checkedVATNumbers) return index;
    Object.values(checkedVATNumbers).forEach(item => {
        if (!index[item.vrn]) {
            index[item.vrn] = item;
        }
    });
    return index;
}

function resolveVATCheckDetails(checkResult, isInProgress) {
    if (isInProgress) {
        return { vatNumberCheck: '', companyCheck: '', extraInfo: 'In Progress' };
    }
    if (!checkResult) {
        return { vatNumberCheck: '', companyCheck: '', extraInfo: 'Not Checked' };
    }
    if (checkResult.isValid) {
        return {
            vatNumberCheck: 'OK',
            companyCheck: checkResult.name,
            extraInfo: checkResult.street + ', ' + checkResult.city
        };
    }
    return {
        vatNumberCheck: 'FAILED',
        companyCheck: '',
        extraInfo: checkResult.errorMessage
    };
}

function buildCSVRowData(row) {
    return [
        row.vatNumber || '', row.totalAmount || '0.00',
        row.totalAmountExclVAT || '0.00', row.totalAmountVAT || '0.00',
        row.inOut || '', row.vatNumberCheck || '', row.name || '',
        row.companyCheck || '', row.extraInfo || '',
        row.invoiceNumber || '', row.supplierInvoiceNumber || ''
    ];
}

function buildTotalRow(totalAmount) {
    const totalAmountColIndex = CSV_HEADERS.findIndex(header => header === 'Total Amount');
    return CSV_HEADERS.map((_, index) =>
        index === totalAmountColIndex ? 'Total Amount: ' + totalAmount.toFixed(2) : ''
    );
}

class LocalListingFilingValues extends Component {

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, { showDrilldown: false, isRequestIdSelected :true, selectedVatNumber: ''});
        this.handleExportCurrentTableToCSV = this.handleExportCurrentTableToCSV.bind(this);
        this.renderExportCurrentTable = this.renderExportCurrentTable.bind(this);
    }

    openDrilldown(lineDetails) {
        this.setState({
            showDrilldown: true,
            selectedVatNumber: lineDetails.vatNumber
        });

        const params = {
            countryCode: this.props.countryCode,
            companyId: this.props.companyId,
            startDate: this.props.filingPeriod && this.props.filingPeriod.fromDate,
            endDate: this.props.filingPeriod && this.props.filingPeriod.toDate,
            vatNumber: lineDetails.vatNumber || '',
            listingLineType: lineDetails.listingLineType || LISTING_TYPE_SALES
        };
        this.props.doOnLineSelect(params);
        this.setState({
            showDrilldown: true,
            selectedVatNumber: lineDetails.vatNumber
        });
    }

    closeDrilldown() {
        this.setState({
            showDrilldown: false,
            selectedVatNumber: ''
        });
    }

    checkVATNumbers(criteria, msInterval) {
      log.debug("checkVATNumbers: criteria %s msInterval %s", criteria, msInterval );
      let requesterVATNumber = this.props.vatNumber;
      function onlyUnique(value,index,self) {
        return self.indexOf(value) === index;
      }

      let vrns = [];
      switch (criteria) {
        case 'all':
          vrns = this.props.filingValues.lines.map(item => item.vatNumber).filter(onlyUnique);
          break;
        case 'failed':
          vrns = this.props.checkedVATNumbers.filter(item => !item.isValid).map(item => item.vrn);
          break;
        default:      // No criteria is a single VAT Number to check
          vrns = [criteria];
          msInterval = 0;
      }
      if(this.state.isRequestIdSelected){
        vrns.forEach((vrn, counter) => {
          // Set a timeout on the request to stagger the calls by msInterval
          setTimeout(() => {
            this.props.checkVATNumberWithRequestId(vrn,requesterVATNumber);
          }, counter * msInterval);
        });
      } else {
        vrns.forEach((vrn, counter) => {
          // Set a timeout on the request to stagger the calls by msInterval
          setTimeout(() => {
            this.props.checkVATNumber(vrn);
          }, counter * msInterval);
        });
      }
    }
    onRequestIdChangeHandler(){
      this.setState({ isRequestIdSelected: !this.state.isRequestIdSelected });
    }
    componentDidUpdate(prevProps) {
      if(!this.state.isRequestIdSelected && prevProps.frequency !== this.props.frequency){
        this.setState({ isRequestIdSelected: true });
      }
    }
    onDrilldown(row){
      log.debug('onDrilldown: row.original: ', row.original);
      const lineDetails = (this.props.filingValues.lines && this.props.filingValues.lines[row.index]) || {};
      this.openDrilldown(lineDetails);
    }

    onSelectReportType(e) {
        log.debug('onSelectReportType(): ', e);
        log.debug('onSelectReportType(): selectedKey:',  e.target.value);
        if(typeof this.props.onReportChangeHandler === 'function') {
            this.setState({ isRequestIdSelected: true });
            this.props.onReportChangeHandler(
                {selectedReportType: e.target.value }
            );
        }
    }

    generateCSVContent(data) {
        if (!data || data.length === 0) {
            return '';
        }

        const csvRows = data.map(row => 
            buildCSVRowData(row).map(escapeCSVField).join(',')
        );

        const totalAmount = data.reduce((sum, row) => sum + (parseFloat(row.totalAmount) || 0), 0);
        const totalRow = buildTotalRow(totalAmount).map(escapeCSVField).join(',');

        return [CSV_HEADERS.join(','), ...csvRows, totalRow].join('\n');
    }

    downloadCSV(csvContent, filename) {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    handleExportCurrentTableToCSV() {
        try {
            const filingLines = (this.props.filingValues && this.props.filingValues.lines) || [];
            if (filingLines.length === 0) {
                log.debug('handleExportCurrentTableToCSV: No filing values data found');
                return;
            }

            const vatIndex = buildCheckedVATIndex(this.props.checkedVATNumbers);
            const inProgressSet = new Set(this.props.checkVATNumbersInProgress);

            const csvData = filingLines.map((row) => {
                const checkDetails = resolveVATCheckDetails(
                    vatIndex[row.vatNumber],
                    inProgressSet.has(row.vatNumber)
                );
                return {
                    vatNumber: row.vatNumber,
                    totalAmount: (parseFloat(row.totalAmount) || 0).toFixed(2),
                    totalAmountExclVAT: (parseFloat(row.amountExclVAT) || 0).toFixed(2),
                    totalAmountVAT: (parseFloat(row.amountVAT) || 0).toFixed(2),
                    inOut: row.listingLineType === LISTING_TYPE_SALES ? 'Out' : 'In',
                    vatNumberCheck: checkDetails.vatNumberCheck,
                    name: row.name || '',
                    companyCheck: checkDetails.companyCheck,
                    extraInfo: checkDetails.extraInfo,
                    invoiceNumber: row.invoiceNumber || '',
                    supplierInvoiceNumber: row.supplierInvoiceNumber || ''
                };
            });

            const csvContent = this.generateCSVContent(sanitizeCsvData(csvData));
            const startDate = this.props.filingPeriod && this.props.filingPeriod.fromDate;
            const endDate = this.props.filingPeriod && this.props.filingPeriod.toDate;
            const listingType = this.props.selectedReportType || 'Sales';
            const filename = `LocalListing_${this.props.countryCode}_${listingType}_${startDate}_${endDate}.csv`;

            this.downloadCSV(csvContent, filename);
            log.debug('handleExportCurrentTableToCSV: CSV export completed successfully');
        } catch (error) {
            log.error('handleExportCurrentTableToCSV: Error during export', error);
        }
    }


    renderExportCurrentTable(totalCount) {
        return totalCount > 0 &&
            <div className='local-listing-export-container mt10 mb10' style={{textAlign: 'left'}}>
                <ExportAll
                    exportLabel='localListing_ExportCurrentTableToCSV'
                    exportClick={() => this.handleExportCurrentTableToCSV()}
                    exportFor='ENABLE_EXPORT_CURRENT_TABLE_LOCAL_LISTING'
                    showToast={false}
                    elementType='btn'
                    elementClassName='local-listing-export-button button secondary'
                />
            </div>
    }

  render() {
        log.debug('render(): this.props ', this.props);

        const filingValues = (this.props.filingValues && this.props.filingValues.lines) || [];
        const localListingData = filingValues.map((localListingRow) => {

            let checkResultsForThisNumber = (this.props.checkedVATNumbers && Object.values(this.props.checkedVATNumbers).filter(item => item.vrn === localListingRow.vatNumber)) || [];

            let thisVATNumberIsValid = (checkResultsForThisNumber[0] && checkResultsForThisNumber[0].isValid) ;

            // Construct extra data to populate the localListingRow for VATNumberCheck details
            localListingRow.VATNumberCheckDetails = {};

            switch (thisVATNumberIsValid){
              case true:
                localListingRow.VATNumberCheckDetails.isValid = "";
                localListingRow.VATNumberCheckDetails.companyName = checkResultsForThisNumber[0].name;
                localListingRow.VATNumberCheckDetails.extraInfo = checkResultsForThisNumber[0].street + ', ' + checkResultsForThisNumber[0].city;
                localListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("OK");
                localListingRow.VATNumberCheckDetails.requestIdentifier = checkResultsForThisNumber[0].requestIdentifier;
                localListingRow.VATNumberCheckDetails.viesCheckDateTime = checkResultsForThisNumber[0].viesCheckDateTime;
                break;
              case false:
                localListingRow.VATNumberCheckDetails.isValid = "false";
                localListingRow.VATNumberCheckDetails.companyName = "";
                localListingRow.VATNumberCheckDetails.extraInfo = checkResultsForThisNumber[0].errorMessage;
                localListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("FAILED");

                break;
              default:
                localListingRow.VATNumberCheckDetails.isValid = "";
                localListingRow.VATNumberCheckDetails.companyName = "";
                localListingRow.VATNumberCheckDetails.extraInfo = VATNumberChecksEnum.getString("NOT_CHECKED");
            }

            // Set status correctly for In Progress state
            if (this.props.checkVATNumbersInProgress.includes(localListingRow.vatNumber)){
              localListingRow.VATNumberCheckDetails.isValid = "";
              localListingRow.VATNumberCheckDetails.companyName = "";
              localListingRow.VATNumberCheckDetails.extraInfo = <LanguageStringResolver string='localListingFilingValues_InProgress'/>;
            }

            return {
                vatNumber: localListingRow.vatNumber,
                totalAmount: localListingRow.totalAmount || 0.0,
                totalAmountExclVAT: localListingRow.amountExclVAT || 0.0,
                totalAmountVAT: localListingRow.amountVAT || 0.0,
                inOut: (localListingRow.listingLineType === LISTING_TYPE_SALES ) ? (
                  <LanguageStringResolver string='localListingFilingReportType_Out' />
                ) : (
                  <LanguageStringResolver string='localListingFilingReportType_In' />
                ),
                vatNumberCheck: localListingRow.vatNumberCheck,
                name:  localListingRow.name,
                companyCheck: localListingRow.VATNumberCheckDetails.companyName,
                extraInfo: localListingRow.VATNumberCheckDetails.extraInfo,
                requestIdentifier:localListingRow.VATNumberCheckDetails.requestIdentifier,
                viesCheckDateTime:localListingRow.VATNumberCheckDetails.viesCheckDateTime
            };
        });


        const columns = [
            { Header:  <span><LanguageStringResolver string='localListingFilingReportType_VATNumber'/></span>, accessor: 'vatNumber',
              Cell: row => ( <button className="link" onClick={this.onDrilldown.bind(this, row)} > {row.value} </button> ),
              Footer: (
                <div className={withFullStoryExclude()} style={{width: '100%', textAlign: 'right'}}>
                    <strong><LanguageStringResolver string='localListingFilingReportType_TotalAmount'/>:&nbsp;</strong>{" "}
                </div>
              )
            },
            {
              id: 'totalAmount',
              Header: <span><LanguageStringResolver string='localListingFilingReportType_TotalAmount' /></span>,
              accessor: 'totalAmount',
              ...ReactComponentHelper.getCurrencyColumnOptions({ isSensitive: true}),
              filterable: false,
              Footer: (
                <span className={withFullStoryExclude()}>
                  {parseFloat(Math.round( _.sum(_.map(localListingData, d => d.totalAmount)) * 100) / 100).toFixed(2)}
                </span>
              )
            },
            {
              id: 'totalAmountExclVAT',
              Header: <span><LanguageStringResolver string='localListingFilingReportType_TotalAmountExclVAT' /></span>,
              accessor: 'totalAmountExclVAT',
              ...ReactComponentHelper.getCurrencyColumnOptions({isSensitive: true}),
              filterable: false,
              minWidth: 120
            },
            {
              id: 'totalAmountVAT',
              Header: <span><LanguageStringResolver string='localListingFilingReportType_TotalAmountVAT' /></span>,
              accessor: 'totalAmountVAT',
              ...ReactComponentHelper.getCurrencyColumnOptions({isSensitive: true}),
              filterable: false
            },
            { Header: <span><LanguageStringResolver string='localListingFilingReportType_InOut' /></span>, accessor: 'inOut', width: 80 },
            { Header: <span><LanguageStringResolver string='localListingFilingReportType_VATNumberCheck' /></span>, minWidth:180, accessor: 'vatNumberCheck',
              Cell: row => (
                <span>
                  {row.original.vatNumberCheck === VATNumberChecksEnum.getValue("NOT_CHECKED")
                              || row.original.vatNumberCheck === VATNumberChecksEnum.getValue("FAILED") ? (
                    <button className="link bold" onClick={this.checkVATNumbers.bind(this,row.original.vatNumber)}>
                      <LanguageStringResolver string='localListingFilingValues_CheckOnline' />
                    </button>
                  ) : (
                    row.original.vatNumberCheck === VATNumberChecksEnum.getValue("OK") ? (
                      (row.original.requestIdentifier !== undefined)?
                      <span>{row.original.viesCheckDateTime + '-'}<LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("OK")} />{ '-' + row.original.requestIdentifier}</span>
                      :<span><LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("OK")} /></span>
                    ) : (<span><LanguageStringResolver string='vatNumberCheckStatus_Unknown' /></span>)
                  )}
                </span>
              )},
            { Header: <span><LanguageStringResolver string='localListingFilingReportType_Name' /></span>, accessor: 'name' },
            { Header: <span><LanguageStringResolver string='localListingFilingReportType_CompanyCheck' /></span>, accessor: 'companyCheck'},
            { Header: <span><LanguageStringResolver string='localListingFilingReportType_ExtraInfo' /></span>, accessor: 'extraInfo',
              Cell: row => (
                <span>
                {
                  (row.original.vatNumberCheck === VATNumberChecksEnum.getValue("FAILED")) ? (
                    row.original.extraInfo === null
                      ? (<span><LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("FAILED")} /></span>)
                      : (
                        (row.original.extraInfo !== <LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("FAILED")} />)
                          ? (<span>{row.original.extraInfo}</span>)
                          : (<span><LanguageStringResolver string='localListingFilingValues_ServiceError'/>: {row.original.extraInfo}</span>)
                      )
                    )
                  : (<span>{row.original.extraInfo}</span>)
                }
                </span>
              )
            }
          ];

        const filingValueDetails = (this.props.filingValueDetails && this.props.filingValueDetails.lines) || [];
        const drillDownData = filingValueDetails.map((localListingRow) =>  {
            return {
                invoiceNumber: localListingRow.invoiceNumber,
                invoiceDate: localListingRow.invoiceDate,
                amount: localListingRow.amount || 0.0,
                amountVAT: localListingRow.amountVAT || 0.0,
                supplierInvoiceNumber: localListingRow.supplierInvoiceNumber
            };
        });

        let totalAmount = (this.props.filingValueDetails && this.props.filingValueDetails.totalAmount) || 0.0;
        let totalAmountVAT = _.sum(_.map(drillDownData, d => d.amountVAT));

        const drillDownColumns = [
                {
                  Header: <span><LanguageStringResolver string='filingValuesDrillDownModal_InvoiceNr' /></span>,
                  accessor: "invoiceNumber",
                  minWidth: 100
                },
                {
                  Header: <span><LanguageStringResolver string='filingValuesDrillDownModal_InvoiceDate' /></span>,
                  accessor: "invoiceDate",
                  Footer: (
                    <div className={withFullStoryExclude()} style={{width: '100%', textAlign: 'right'}}>
                      <strong><LanguageStringResolver string='filingValuesDrillDownModal_Total'/></strong>: {''}
                    </div>
                  )
                },
                {
                  id: 'amount',
                  Header: <span>  <LanguageStringResolver string='filingValuesDrillDownModal_Amount' /></span>,
                  accessor: "amount",
                  ...ReactComponentHelper.getCurrencyColumnOptions({isSensitive: true}),
                  filterable: false,
                  Footer: (<span className={withFullStoryExclude()}>{parseFloat(Math.round( totalAmount * 100) / 100).toFixed(2)}</span>)
                },
                {
                  id: 'amountVAT',
                  Header: <span><LanguageStringResolver string='filingValuesDrillDownModal_AmountVAT'/></span>,
                  accessor: "amountVAT",
                  ...ReactComponentHelper.getCurrencyColumnOptions({isSensitive: true}),
                  filterable: false,
                  Footer: (<span className={withFullStoryExclude()}>{parseFloat(Math.round( totalAmountVAT * 100) / 100).toFixed(2)}</span>)
                },
                {
                  Header: <span><LanguageStringResolver string='filingValuesDrillDownModal_SupplierInvoiceNr' /></span>,
                  accessor: "supplierInvoiceNumber",
                  minWidth: 180
                }
            ];

        const NoDataComponent = props => (
          <NoData
            noDataText="filingValues_noData"
            {...props}
          />
        );

        return (
            <div>
              <s-row>
                <s-col span="6">
                  <fieldset>
                    <label>{<LanguageStringResolver string='filingReportType_ReportType' />}</label>
                    <FilingReportTypeSelector flowTypes={Object.keys(LocalListingFlowEnum.props).filter((el) => el !== LocalListingFlowEnum.NONE)} selectValue={this.props.selectedReportType}
                        onChange={(e) => this.onSelectReportType(e)}></FilingReportTypeSelector>
                  </fieldset>
                  <div className="mt20 mb20">
                    <button className="link" onClick={this.checkVATNumbers.bind(this, 'all', 150)}>
                      <LanguageStringResolver string='localListingFilingValues_CheckAll'/>
                    </button>
                    {(this.props.checkedVATNumbers.filter(item => !item.isValid).length === 0) ? (
                      <span></span>
                    ) : (
                      <span>
                        <span className="divider-left margin-left-sm margin-right-sm"></span>
                        <button className="tertiary" onClick={this.checkVATNumbers.bind(this, 'failed', 150)}>
                          <LanguageStringResolver string='localListingFilingValues_CheckFailed'/>
                        </button>
                      </span>
                    )}
                    <span className="divider-left margin-left-sm margin-right-sm"></span>
                    <fieldset className="inline">
                      <input className="checkbox" type="checkbox" id="r1" checked ={this.state.isRequestIdSelected} onClick={this.onRequestIdChangeHandler.bind(this)} aria-checked="false" />
                      <label className="checkbox" ><LanguageStringResolver string='localListingFilingValues_RequestID'/></label>
                    </fieldset>
                  </div>
                </s-col>
              </s-row>
              <ReactTable
                data={localListingData}
                columns={columns}
                className={'mb15'}
                resizable={true}
                sortable={false}
                minRows={0}
                maxRows={0}
                showPageJump={false}
                noDataText={<LanguageStringResolver string='localListingFilingReportType_NoData' />}
                defaultPageSize={20}
                pageSizeOptions={[ 20, 50, 100, 1000]}
                showPagination={filingValues.length !== 0}
                PaginationComponent={Pagination}
                NoDataComponent={NoDataComponent}
              />
              {this.renderExportCurrentTable(filingValues.length)}
              <br/>
              <DrilldownModal
                open={this.state.showDrilldown}
                onClose={this.closeDrilldown.bind(this)}
                title={<LanguageStringResolver string='localListingRowDrilldown_title'/>}
                cols={drillDownColumns}
                data={drillDownData}
                sortable={false}
                companyId={this.props.companyId}
                vatNumber={this.state.selectedVatNumber}
                modalStyles={modalStyle}
              />
            </div>
        );
    }
}

// Make Redux State elements available as props in this component
function mapStateToProps(state) {
    log.debug('mapStateToProps(): ', state);
    return {
      filingValueDetails: (state.filing && state.filing.filingValueDetails) || {},
      checkedVATNumbers: state.filing.checkedVATNumbers || [],
      checkVATNumbersInProgress: state.filing.checkVATNumbersInProgress || []
    }
}

// Interface to the controller methods to be called in this component as props
function mapDispatchToProps(dispatch) {
    log.debug('mapDispatchToProps(): ');
    return {
      checkVATNumber: (vatNumber) => {
        log.debug("checkVATNumber: vatNumber: ", vatNumber);
        dispatch(FILING_CONTROLLER.checkVATNumber(vatNumber))
      },
      checkVATNumberWithRequestId: (vatNumber, requesterVATNumber) => {
        log.debug("checkVATNumber: vatNumber: requesterVATNumber", vatNumber, requesterVATNumber);
        dispatch(FILING_CONTROLLER.checkVATNumberWithRequestId(vatNumber, requesterVATNumber))
      },
      doOnLineSelect: (params) => {
          log.debug("doLineSelect(): params: ", params);

          dispatch(FILING_CONTROLLER.doLoadLocalListingValueDetails({
              countryCode: params.countryCode,
              companyId: params.companyId,
              startDate: params.startDate,
              endDate: params.endDate,
              vatNumberCustomer: params.vatNumber,
              // By defaults show sales listing
              listingLineType: params.listingLineType
          }));
      }
    };
}

// Constrain the props passed into this component

// Set default props into this component
LocalListingFilingValues.defaultProps = {

};

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchToProps)(LocalListingFilingValues);
